<template>
  <div class="relative">
    <div class="p-10 w-full">
      <div class="mb-2">
        <span class="text-zt-lg font-normal modal-title">{{ $t('message.settingsComponent.list.mfaSettings.dialogTitle') }}</span>
      </div>
      <div class="mt-2">
        <span class="text-zt-md text-zt-dark-300">
          {{ $t('message.settingsComponent.list.mfaSettings.info') }}
        </span>
      </div>
      <div class="flex flex-wrap mt-6">
        <div class="w-full">
          <zt-radio-button
            :id="1"
            value="yes"
            name="mfa-config"
            v-model="valueSelected"
            :class="{ disabledClass: disableSelect}"
          >
            {{ $t('message.settingsComponent.list.mfaSettings.yes') }}
          </zt-radio-button>
        </div>
        <div class="w-full">
          <zt-radio-button
            :id="2"
            value="no"
            name="mfa-config"
            v-model="valueSelected"
            :disabled="disableSelect"
             :class="{ disabledClass: disableSelect}"
            
          >
            {{ $t('message.settingsComponent.list.mfaSettings.no') }}
          </zt-radio-button>
        </div>
        <span class="text-zt-md text-zt-dark-300 pt-4">
          {{ $t('message.settingsComponent.list.mfaSettings.passRequiredInfo') }}
        </span>
      <zt-input outlined name="typeAccount" class="w-full my-2" v-model="password"  @input="checkFormValidity"
        :label="$t('message.settingsComponent.list.mfaSettings.passwordLabel')" type="password" data-vs-input="passwordAccount" />
      
      </div>
      <div v-if="warnMessage" class="w-full mt-4 border border-solid warning-box flex items-center p-4 md:p-6">
        <div class="w-2/12 md:pl-2 my-auto">
          <svg xmlns="http://www.w3.org/2000/svg" width="31" height="31" fill="none" viewBox="0 0 31 31">
            <path fill="#2D2D2D" fill-rule="evenodd" d="M26.462 26.465C23.559 29.367 19.614 31 15.5 31c-4.113 0-8.06-1.62-10.964-4.537C1.635 23.55 0 19.62 0 15.507v-.003c.014-4.098 1.649-8.027 4.55-10.928l.002-.001C7.308 1.833 10.971.235 14.826.068V0h.674c4.112 0 8.058 1.619 10.962 4.535C29.38 7.437 31.014 11.381 31 15.508c0 4.11-1.62 8.054-4.538 10.957zM16.174 1.363v.038H15.5c-3.743 0-7.332 1.479-9.996 4.128-2.65 2.649-4.143 6.236-4.156 9.979 0 3.754 1.492 7.342 4.144 10.005 2.648 2.66 6.25 4.14 10.008 4.14 3.757 0 7.36-1.492 10.01-4.141v-.001c2.662-2.648 4.142-6.247 4.142-10.004v-.003c.013-3.767-1.479-7.366-4.141-10.015l-.003-.002c-2.49-2.5-5.821-3.958-9.334-4.124z" clip-rule="evenodd"/>
            <path fill="#2D2D2D" fill-rule="evenodd" d="M15.514 13.108c.74 0 1.347.607 1.347 1.348v5.389c0 .74-.606 1.347-1.348 1.347-.74 0-1.347-.606-1.347-1.347v-5.39c0-.74.593-1.347 1.348-1.347z" clip-rule="evenodd"/>
            <path fill="#2D2D2D" d="M15.514 10.414c-.742 0-1.348-.606-1.348-1.347s.606-1.347 1.348-1.347c.74 0 1.347.606 1.347 1.347 0 .74-.606 1.347-1.348 1.347z"/>
          </svg>
        </div>
        <div class="w-10/12">
          <p class="text-zt-md text-zt-danger font-bold">
            {{ warnMessage }}
          </p>
        </div>
      </div>
    </div>
    <div class="zt-modal-footer flex justify-center lg:justify-end items-center p-4 fixed md:relative bottom-0 right-0 left-0 pb-4">
      <div class="w-1/2 md:w-1/4">
        <zt-button
          class="ml-1 button-cancel-only-text w-11/12"
          text
          @click="$emit('close')"
          >{{ $t('message.settingsComponent.list.buttonCancel') }}</zt-button
        >
      </div>
      <div class="w-1/2 md:w-1/4">
        <zt-button
          class="ml-1 w-11/12"
          :loader="loading"
          :disabled="disabled"
          @click="saveSettings"
          >{{ $t('message.settingsComponent.list.save') }}</zt-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import Mfa from '@/apiClient/Mfa'
import Users from '@/apiClient/Users'

export default {
  data() {
    return {
      mfa: Mfa,
      valueSelected: '',
      initValue: '',
      loading: false,
      disabled: true,
      warnMessage: '',
      disableSelect: false,
      user: this.$store.state.user.usuario,
      password:'',

    }
  },
  created() {
    this.userService = new Users()
    if(!this.$store.state.user.hasEmployeeMandatoryMFA){ 
    this.mfa = new Mfa()
    this.mfa.getMfaConfig().then(response => {
      this.initValue = 'yes'
      this.valueSelected = 'yes'
    }).catch(e => {
      this.initValue = 'no'
      this.valueSelected = 'no'
    })}
    else {
      this.initValue = 'yes'
      this.valueSelected = 'yes'
      this.warnMessage =   this.$t('message.settingsComponent.list.mfaSettings.notEditable')
      this.disableSelect = true
      this.disabled = true
  }
  },
  watch: {
    valueSelected(val) {
      this.checkFormValidity()
    },
    password(val) {
      this.checkFormValidity()
    }
  },
  methods: {
    async saveSettings() {
    this.loading = true;
    this.warnMessage = ''; // Restablecer cualquier mensaje previo.

    try {
      // Intentar validar la contraseña
      const isValidPassword = await this.userService.validPass(this.password);
      
      if (!isValidPassword) {
        this.warnMessage = this.$t('message.settingsComponent.list.mfaSettings.invalidPassword');
        this.loading = false;
        return; // Salir si la contraseña no es válida.
      }

      // Proceder con la configuración MFA si la contraseña es válida
      if (this.valueSelected === 'yes') {
        await this.mfa.saveMfaConfig();
        this.$emit('logout');
      } else {
        await this.mfa.deleteMfaConfig();
        this.$emit('close');
      }
      
    } catch (error) {
      if (error.response && error.response.status === 400) {
        this.warnMessage = this.$t('message.settingsComponent.list.mfaSettings.invalidPassword');
      } else {
        this.warnMessage = this.$t('message.settingsComponent.list.mfaSettings.errorSavingSettings');
       
      }
    } finally {
      this.loading = false;
    }
  
    },
    checkFormValidity() {
      this.disabled = !this.password || this.valueSelected === this.initValue;

      if (!this.password && this.valueSelected !== this.initValue) {
        this.warnMessage = this.$t('message.settingsComponent.list.mfaSettings.passRequired');
      } else if (this.valueSelected === this.initValue) {
        this.warnMessage = '';
      } else {
        this.warnMessage = this.valueSelected === 'yes' 
          ? this.$t('message.settingsComponent.list.mfaSettings.warnMessageMfaYes') 
          : this.$t('message.settingsComponent.list.mfaSettings.warnMessageMfaNo');
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.modal-title {
  color: #575757;
}
.disabledClass{
  color: grey;
}
@media screen and (min-width: 1024px) {
  .zt-modal-footer {
    background-color: #eeeeee;
    .button-cancel-only-text {
      background-color: #eeeeee !important;
      color: #949494 !important;
    }
  }
}
.zt-modal-footer {
  .zt-button {
    font-weight: 500;
    box-shadow: none;
  }
  .button-cancel-only-text {
    color: #949494 !important;
  }
}
.warning-box {
  border-color: #707070;
}
</style>